import { render, staticRenderFns } from "./SGPoolConfigs.vue?vue&type=template&id=35f6ae8e"
import script from "./SGPoolConfigs.vue?vue&type=script&lang=js"
export * from "./SGPoolConfigs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports